import React from "react";
import { NewsType } from "../domain/News";
import { NewsState } from "../redux/state";
import { NewsListItem } from "./NewsListItem";
import { NewsListItemGovUk } from "./NewsListItemGovUk";

export const NewsList: React.FC<{ newsState: NewsState }> = ({ newsState }) => {
  const { response } = newsState;
  return (
    <React.Fragment>
      {response.data.map((item) =>
        item.type === NewsType.GovUk ? (
          <NewsListItemGovUk newsItem={item} key={item.id} />
        ) : (
          <NewsListItem newsItem={item} key={item.id} />
        )
      )}
    </React.Fragment>
  );
};
